/* eslint-disable space-before-function-paren */
/* eslint-disable no-unused-vars */
import { a } from 'bowser';
import ScratchBlocks from 'openblock-blocks';
import { getScannedDevicesAsOptions , getScannedDevices_adc , getScannedDevices_i2c , getScannedDevices_TCS3472 , getScannedDevices_VL6180X , getScannedDevices_BME680 , getScannedDevices_OLED , getScannedDevices_HW484} from './scanned-devices-store.js';

/**
 * Define custom demo blocks
 * @param {object} ScratchBlocksInstance - The ScratchBlocks namespace
 */
export const defineDemoBlocks = ScratchBlocksInstance => {
    // Demo Hello Block
    ScratchBlocksInstance.Blocks.demo_hello = {
        init: function() {
            this.jsonInit({
                message0: 'Demo Hello %1',
                args0: [
                    {
                        type: 'input_value',
                        name: 'MESSAGE',
                        check: 'String'
                    }
                ],
                colour: '#9B59B6',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Demo'
            });
        }
    };

    // Demo LED ON Block
    ScratchBlocksInstance.Blocks.demo_led_on = {
        init: function() {
            this.jsonInit({
                message0: 'Demo LED ON',
                colour: '#9B59B6',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Demo'
            });
        }
    };

    // Demo LED OFF Block
    ScratchBlocksInstance.Blocks.demo_led_off = {
        init: function() {
            this.jsonInit({
                message0: 'Demo LED OFF',
                colour: '#9B59B6',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Demo'
            });
        }
    };

    // Demo Delay Block
    ScratchBlocksInstance.Blocks.demo_delay = {
        init: function() {
            this.jsonInit({
                message0: 'Demo Delay %1 ms',
                args0: [
                    {
                        type: 'input_value',
                        name: 'DELAY',
                        check: 'Number'
                    }
                ],
                colour: '#9B59B6',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Demo'
            });
        }
    };

    // Demo Clear Screen Block
    ScratchBlocksInstance.Blocks.demo_clear_screen = {
        init: function() {
            this.jsonInit({
                message0: 'Demo Clear Screen',
                colour: '#9B59B6',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Demo'
            });
        }
    };

    // Demo Motor Start Block
    ScratchBlocksInstance.Blocks.demo_motor_start = {
        init: function() {
            this.jsonInit({
                message0: '%1 Khởi động động cơ',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    }
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Động cơ'
            });
        }
    };

    // motor_custom block
    ScratchBlocksInstance.Blocks.motor_custom = {
        init: function() {
            this.jsonInit({
            message0: '%1 Động cơ tại cổng %2  %3',
            args0: [
                {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'motor',
                    options: [
                        ['M1', '1'],
                        ['M2', '2']     
                    ]
                },
                {
                    type: 'field_dropdown',
                    name: 'mode',
                    options: [
                        ['Tien', 'Tien'],
                        ['Lui', 'Lui'],
                        ['Dung', 'Dung']
                    ]
                }
            ],
            colour: '#D32F2F',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            previousStatement: null,
            nextStatement: null,
            category: 'Động cơ'
            });
        }
    };


    // Demo Robot Move Backward Block
    ScratchBlocksInstance.Blocks.demo_robot_back = {
        init: function() {
            this.jsonInit({
                message0: '%1 Robot lùi lại',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Động cơ'
            });
        }
    };

    // Demo Robot Turn Right Block
    ScratchBlocksInstance.Blocks.demo_robot_turn_right = {
        init: function() {
            this.jsonInit({
                message0: '%1 Robot rẽ phải',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Động cơ'
            });
        }
    };

    // Demo Robot Turn Left Block
    ScratchBlocksInstance.Blocks.demo_robot_turn_left = {
        init: function() {
            this.jsonInit({
                message0: '%1 Robot rẽ trái',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Động cơ'
            });
        }
    };

    // Demo Robot Move Forward Block
    ScratchBlocksInstance.Blocks.demo_robot_forward = {
        init: function() {
            this.jsonInit({
                message0: '%1 Robot tiến lên',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Động cơ'
            });
        }
    };

    // Demo Robot Stop Block
    ScratchBlocksInstance.Blocks.demo_robot_stop = {
        init: function() {
            this.jsonInit({
                message0: '%1 Robot dừng lại',
                args0: [
                    {   
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Demo'
            });
        }
    };

    // Demo Oled start Block
    ScratchBlocksInstance.Blocks.demo_OLED_start = {
        init: function() {
            this.jsonInit({
                message0: '%1  Khởi động OLED',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/screen_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    }
                ],
                colour: '#118b11ff',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Màn hình'
            });
        }
    };

    // Robot display emotion Block
    ScratchBlocksInstance.Blocks.demo_robot_emotion = {
        init: function() {
            this.jsonInit({
                message0: '%1  Robot hiển thị cảm xúc %2',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/screen_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                    {
                        type: 'field_dropdown',
                        name: 'EMOTION',
                        options: [
                            ['Mắt chớp', 'Mat_chop'],
                            ['Cười híp mắt', 'Cuoi_hip_mat'],
                            ['Mặt cười', 'Mat_cuoi'],
                            ['Mặt buồn', 'Mat_buon'],
                            ['Mặt nói chuyện', 'Mat_noi_chuyen'],
                            ['Nhức mắt', 'Nhuc_mat'],
                            ['Xoay vòng', 'Xoay_vong'],
                            ['Mắt cute', 'Mat_cute'],
                            ['Cười haha', 'Cuoi_haha'],
                            ['Mặt cáu kỉnh', 'Mat_cau_kinh'],
                            ['Mặt tức giận', 'Mat_tuc_gian'],
                            ['Mặt đang ngủ', 'Mat_dangngu'],
                            ['Mặt ngầu', 'Mat_ngau'],
                            ['Mặt quý ông', 'Mat_quy_ong']
                        ]
                    }
                ],
                colour: '#118b11ff',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Màn hình'
            });
        }
    };

    // OLED display input Block
    ScratchBlocksInstance.Blocks.demo_robot_oled_display = {
        init: function() {
            this.jsonInit({
                message0: '%1 In (0-168 ký tự không dấu) %2 với hiệu ứng %3 , tọa độ x: %4 , y: %5 , cỡ chữ (1-3): %6 ',
                args0: [
                     {
                        type: 'field_image',
                        src: 'static/assets/screen_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                    {
                        type: 'input_value',
                        name: 'MESSAGE',
                        check: 'String'
                    },
                    {
                        type: 'field_dropdown',
                        name: 'EFFECT',
                        options: [
                            ['Left2Right', 'Left2Right'],
                            ['Right2Left', 'Right2Left'],
                            ['Bottom2Top', 'Bottom2Top'],
                            ['Top2Bottom', 'Top2Bottom']
                        ]
                    },
                    {
                        type: 'input_value',
                        name: 'POS_X',
                        check: 'Number'
                    },
                    {
                        type: 'input_value',
                        name: 'POS_Y',
                        check: 'Number'
                    },
                    {
                        type: 'input_value',
                        name: 'TEXT_SIZE',
                        check: 'Number'
                    }
                ],
                inputsInline: true,
                colour: '#118b11ff',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Màn hình'
            });
        }
    };

    // oled_text block
    ScratchBlocksInstance.Blocks.oled_text = {
        init: function() {
            this.jsonInit({
                message0: '%1 In (0-168 ký tự không dấu) %2 tại tọa độ x: %3 , y: %4 với cỡ chữ (1-3): %5 ',
                args0: [
                     {
                        type: 'field_image',
                        src: 'static/assets/screen_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                    {
                        type: 'input_value',
                        name: 'MESSAGE',
                        check: 'String'
                    },
                    {
                        type: 'input_value',
                        name: 'POS_X',
                        check: 'Number'
                    },
                    {
                        type: 'input_value',
                        name: 'POS_Y',
                        check: 'Number'
                    },
                    {
                        type: 'input_value',
                        name: 'TEXT_SIZE',
                        check: 'Number'
                    }
                ],
                inputsInline: true,
                colour: '#118b11ff',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Màn hình'
            });
        }
    };

    // oled_number block
    ScratchBlocksInstance.Blocks.oled_number = {
        init: function() {
            this.jsonInit({
                message0: '%1 Ghi (số) %2 tại tọa độ x: %3 , y: %4 với cỡ chữ (1-3): %5',
                args0: [
                     {
                        type: 'field_image',
                        src: 'static/assets/screen_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                    {
                        type: 'input_value',
                        name: 'MESSAGE',
                        check: ['Number','String']
                    },
                    {
                        type: 'input_value',
                        name: 'POS_X',
                        check: 'Number'
                    },
                    {
                        type: 'input_value',
                        name: 'POS_Y',
                        check: 'Number'
                    },
                    {
                        type: 'input_value',
                        name: 'TEXT_SIZE',
                        check: 'Number'
                    }
                ],
                inputsInline: true,
                colour: '#118b11ff',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Màn hình'
            });
        }
    };

    // demo whistle block
    ScratchBlocksInstance.Blocks.demo_buzzer_start = {
        init: function() {
            this.jsonInit({
                message0: 'Khởi động còi',
                colour: '#F9A825',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Còi chip'
            });
        }
    };

    // demo alarm block
    ScratchBlocksInstance.Blocks.demo_buzzer_alarm = {
        init: function() {
            this.jsonInit({
                message0: 'Còi kêu báo thức',
                colour: '#F9A825',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Còi chip'
            });
        }
    };

    // demo warning danger block
    ScratchBlocksInstance.Blocks.demo_warining_danger = {
        init: function() {
            this.jsonInit({
                message0: 'Còi kêu cảnh báo nguy hiểm',
                colour: '#F9A825',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Còi chip'
            });
        }
    };

    // demo turn off whistle block
    ScratchBlocksInstance.Blocks.demo_turn_off_buzzer = {
        init: function() {
            this.jsonInit({
                message0: 'Tắt còi',
                colour: '#F9A825',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Còi chip'
            });
        }
    };

    // vibration_start block
    ScratchBlocksInstance.Blocks.vibration_start = {
        init: function() {
            this.jsonInit({
                message0: 'Khởi động cảm biến rung',
                colour: '#400D1A',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Cảm biến rung'
            });
        }
    };

    // vibration_value block 
    ScratchBlocksInstance.Blocks.vibration_value = {
        init: function() {
            this.jsonInit({
            message0: 'Đo độ rung (0-1023)',
            colour: '#400D1A',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'bluetooth',
            extensions: ["output_number"],
            category: 'Cảm biến rung'
            });
        }
    };

    // demo Vibration sensor block
    ScratchBlocksInstance.Blocks.demo_vibration_sensor = {
        init: function() {
            this.jsonInit({
                message0: 'Đọc cảm biến rung',
                colour: '#400D1A',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Cảm biến rung'
            });
        }
    };

    // solar_start block
    ScratchBlocksInstance.Blocks.solar_start = {
        init: function() {
            this.jsonInit({
                message0: '%1 Khởi động cảm biến ánh sáng',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/sun_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    }
                ],
                colour: '#0B3D20',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Cảm biến ánh sáng'
            });
        }
    };

    // solar_value block 
    ScratchBlocksInstance.Blocks.solar_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Đo độ sáng (0-100%)',
            args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/sun_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    }
                ],
            colour: '#0B3D20',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'bluetooth',
            extensions: ["output_number"],
            category: 'Cảm biến ánh sáng'
            });
        }
    };

    // demo solar sensor block
    ScratchBlocksInstance.Blocks.demo_solar_sensor = {
        init: function() {
            this.jsonInit({
                message0: 'Đọc cảm biến ánh sáng',
                colour: '#0B3D20',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'Cảm biến ánh sáng'
            });
        }
    };

    // Irsensor block
    ScratchBlocksInstance.Blocks.Irsensor_block = {
        init: function() {
            this.jsonInit({
                message0: '%1 Khởi động cảm biến hồng ngoại tại cổng %2',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/remote_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                    {
                        type: 'field_dropdown',
                        name: 'AnalogPin',
                        options: [
                            ['A1', 'A1'],
                            ['A2', 'A2']
                        ]
                    }
                ],
                colour: '#d69429ff',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category:'Cảm biến vật cản'
            });
        }
    };

    // detect object block
    ScratchBlocksInstance.Blocks.detect_object = {
        init: function() {
            this.jsonInit({
            message0: '%1 Phát hiện vật cản tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/remote_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'AnalogPin',
                    options: [
                        ['A1', 'A1'],
                        ['A2', 'A2']
                    ]
                }
            ],
            colour: '#d69429ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Cảm biến vật cản',
            extensions: ["output_boolean"],
            });
        }
    };

    // Cam bien hong ngoai 
    ScratchBlocksInstance.Blocks.infrared_sensor_start = {
        init: function() {
            this.jsonInit({
            message0: '%1 Khởi động điều khiển',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/remote_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#2563EB',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Cảm biến hồng ngoại',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // neu nhan nut noi dieu khien 
    ScratchBlocksInstance.Blocks.infrared_sensor_button = {
        init: function() {
            this.jsonInit({
            message0: '%1 Tín hiệu nút đang nhấn là %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/remote_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'ButtonSelect',
                    options: [
                        ['BUTTON_1', '1'],
                        ['BUTTON_2', '2'],
                        ['BUTTON_3', '3'],
                        ['BUTTON_4', '4'],
                        ['BUTTON_5', '5'],
                        ['BUTTON_6', '6'],
                        ['BUTTON_7', '7'],
                        ['BUTTON_8', '8'],
                        ['BUTTON_9', '9'],
                        ['BUTTON_0', '0'],
                        ['BUTTON_*', 'ASTERIK'],
                        ['BUTTON_#', 'POUND'],
                        ['BUTTON_UP', 'UP'],
                        ['BUTTON_DOWN', 'DOWN'],
                        ['BUTTON_LEFT', 'LEFT'],
                        ['BUTTON_RIGHT', 'RIGHT'],
                        ['BUTTON_OK', 'OK']
                    ]
                }
            ],
            colour: '#2563EB',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Cảm biến hồng ngoại',
            extensions: ["output_boolean"],
            });
        }
    };

    // infrared_sensor_test block
    ScratchBlocksInstance.Blocks.infrared_sensor_test = {
        init: function() {
            this.jsonInit({
            message0: '%1 Kiểm tra tín hiệu hồng ngoại',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/remote_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#2563EB',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Cảm biến hồng ngoại',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // button_start block
    ScratchBlocksInstance.Blocks.button_start = {
        init: function() {
            this.jsonInit({
            message0: '%1 Khởi động nút nhấn',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/button_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#9966FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Nút nhấn',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // left_button_value block
    ScratchBlocksInstance.Blocks.left_button_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Nút nhấn bên trái bằng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/button_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'button_value',
                    check: 'Number'
                }
            ],
            colour: '#9966FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Nút nhấn',
            extensions: ["output_boolean"],
            });
        }
    };

    // right_button_value block
    ScratchBlocksInstance.Blocks.right_button_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Nút nhấn bên phải bằng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/button_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'button_value',
                    check: 'Number'
                }
            ],
            colour: '#9966FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Nút nhấn',
            extensions: ["output_boolean"],
            });
        }
    };

    // setting_toggle_button block
    ScratchBlocksInstance.Blocks.setting_toggle_button = {
        init: function() {
            this.jsonInit({
            message0: '%1 Cài đặt số lần nhấn nút bên phải bằng %2 , số lần nhấn nút bên trái bằng %3',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/button_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'right_button_value',
                    check: 'Number'
                },
                {
                    type: 'input_value',
                    name: 'left_button_value',
                    check: 'Number'
                }
            ],
            colour: '#9966FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Nút nhấn',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // bluetooth_start block
    ScratchBlocksInstance.Blocks.bluetooth_start = {
        init: function() {
            this.jsonInit({
            message0: 'Khởi động bluetooth',
            colour: '#00ACC1',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'bluetooth',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // bluetooth_test block
    ScratchBlocksInstance.Blocks.bluetooth_test = {
        init: function() {
            this.jsonInit({
            message0: 'Kiểm tra kết nối Bluetooth',
            colour: '#00ACC1',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'bluetooth',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // signal_from block
    ScratchBlocksInstance.Blocks.signal_from = {
        init: function() {
            this.jsonInit({
            message0: 'Tín hiệu từ %1 là %2',
            args0: [
                {
                    type: 'field_dropdown',
                    name: 'switch',
                    options: [
                        ['switch1', '1'],
                        ['switch2', '2'],
                        ['switch3', '3'],
                        ['switch4', '4'],
                        ['switch5', '5'],
                        ['switch6', '6']          
                    ]
                },
                {
                    type: 'field_dropdown',
                    name: 'mode',
                    options: [
                        ['ON', '1'],
                        ['OFF', '0']
                    ]
                }
            ],
            colour: '#00ACC1',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'bluetooth',
            extensions: ["output_boolean"],
            });
        }
    };

    // send_text block
    ScratchBlocksInstance.Blocks.send_text = {
        init: function() {
            this.jsonInit({
            message0: 'Gửi tín hiệu %1 tới điện thoại',
            args0: [
                {
                    type: 'input_value',
                    name: 'message',
                    check: 'String'
                }
            ],
            colour: '#00ACC1',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'bluetooth',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // dimmer_value block
    ScratchBlocksInstance.Blocks.dimmer_value = {
        init: function() {
            this.jsonInit({
            message0: 'Đọc giá trị từ dimmer',
            colour: '#00ACC1',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'bluetooth',
            extensions: ["output_string"],
            });
        }
    };

    // sinal_from_gamepad block
    ScratchBlocksInstance.Blocks.sinal_from_gamepad = {
        init: function() {
            this.jsonInit({
            message0: 'Tín hiệu từ GAMEPAD là %1',
            args0: [
                {
                    type: 'field_dropdown',
                    name: 'gamepad_value',
                    options: [
                        ['Y', 'Y'],
                        ['A', 'A'],
                        ['X', 'X'],
                        ['B', 'B']       
                    ]
                }
            ],
            colour: '#00ACC1',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'bluetooth',
            extensions: ["output_boolean"],
            });
        }
    };

    // signal_from_void_controll block
    ScratchBlocksInstance.Blocks.signal_from_void_controll = {
        init: function() {
            this.jsonInit({
            message0: 'Tín hiệu từ Void Controll là %1',
            args0: [
                {
                    type: 'input_value',
                    name: 'void_controll_value',
                    check: 'String'
                }
            ],
            colour: '#00ACC1',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'bluetooth',
            extensions: ["output_boolean"],
            });
        }
    };

    // color_picker_value block
    ScratchBlocksInstance.Blocks.color_picker_value = {
        init: function() {
            this.jsonInit({
            message0: 'Đọc giá trị từ Color Picker',
            colour: '#00ACC1',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'bluetooth',
            extensions: ["output_number"],
            });
        }
    };

    // signal_from_terminal block
    ScratchBlocksInstance.Blocks.signal_from_terminal = {
        init: function() {
            this.jsonInit({
            message0: 'Tín hiệu từ Terminal là %1',
            args0: [
                {
                    type: 'input_value',
                    name: 'Terminal_value',
                    check: 'String'
                }
            ],
            colour: '#00ACC1',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'bluetooth',
            extensions: ["output_boolean"],
            });
        }
    };

    // example_star_war block
    ScratchBlocksInstance.Blocks.example_star_war = {
        init: function() {
            this.jsonInit({
            message0: 'Star War',
            colour: '#00FF00',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'example',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // example_soccer_player block
    ScratchBlocksInstance.Blocks.example_soccer_player = {
        init: function() {
            this.jsonInit({
            message0: 'Cầu thủ bóng đá',
            colour: '#00FF00',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'example',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // led_start block
    ScratchBlocksInstance.Blocks.led_start = {
        init: function() {
            this.jsonInit({
            message0: '%1 Khởi động đèn tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/led_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'led_pin',
                    options: [
                        ['B0', '1'],
                        ['B1', '0']     
                    ]
                }
            ],
            colour: '#f60e4cff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'led',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // led_mode_on_pin block
    ScratchBlocksInstance.Blocks.led_mode_on_pin = {
        init: function() {
            this.jsonInit({
            message0: '%1 %2 đèn tại cổng %3',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/led_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'mode',
                    options: [
                        ['Bật', '1'],
                        ['Tắt', '0']     
                    ]
                },
                {
                    type: 'field_dropdown',
                    name: 'pin',
                    options: [
                        ['B0', '1'],
                        ['B1', '0']     
                    ]
                }
            ],
            colour: '#f60e4cff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'led',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // led_on_effect block
    ScratchBlocksInstance.Blocks.led_on_effect = {
        init: function() {
            this.jsonInit({
            message0: '%1 Đèn sáng dần trong %2 giây tại cổng %3',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/led_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'time',
                    check: 'Number'
                },
                {
                    type: 'field_dropdown',
                    name: 'pin',
                    options: [
                        ['B0', '1'],
                        ['B1', '0']     
                    ]
                }
            ],
            colour: '#f60e4cff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'led',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };    

    // led_off_effect block
    ScratchBlocksInstance.Blocks.led_off_effect = {
        init: function() {
            this.jsonInit({
            message0: '%1 Đèn tối dần trong %2 giây tại cổng %3',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/led_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'time',
                    check: 'Number'
                },
                {
                    type: 'field_dropdown',
                    name: 'pin',
                    options: [
                        ['B0', '1'],
                        ['B1', '0']     
                    ]
                }
            ],
            colour: '#f60e4cff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'led',
            previousStatement: null,
            nextStatement: null,
            });
        }
    }; 

    // led_on_intensity block
    ScratchBlocksInstance.Blocks.led_on_intensity = {
        init: function() {
            this.jsonInit({
            message0: '%1 Bật đèn tại cổng %2 với mức sáng %3 (0-100%)',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/led_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'pin',
                    options: [
                        ['B0', '1'],
                        ['B1', '0']     
                    ]
                },
                {
                    type: 'input_value',
                    name: 'intensity',
                    check: 'Number'
                } 
            ],
            colour: '#f60e4cff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'led',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // timer_setup block
    ScratchBlocksInstance.Blocks.timer_setup = {
        init: function() {
            this.jsonInit({
            message0: '%1 Khởi động thời gian',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/timer_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#ff22fbff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Hẹn giờ',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // timer_limit block
    ScratchBlocksInstance.Blocks.timer_limit = {
        init: function() {
            this.jsonInit({
            message0: '%1 Thiết lập thời gian đếm tối đa là %2 giây',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/timer_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'time',
                    check: 'Number'
                }
            ],
            colour: '#ff22fbff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Hẹn giờ',
            previousStatement: null,
            nextStatement: null,
            });
        }
    }; 

    // timer_value block
    ScratchBlocksInstance.Blocks.timer_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Thời gian bằng %2 giây',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/timer_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'time',
                    check: 'Number'
                }
            ],
            colour: '#ff22fbff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Hẹn giờ',
            extensions: ["output_boolean"],
            });
        }
    };

    // password_setup block
    ScratchBlocksInstance.Blocks.password_setup = {
        init: function() {
            this.jsonInit({
            message0: '%1 Khởi động mật khẩu là %2 %3 %4 %5 Điều khiển tại cổng %6',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/password_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'pass1',
                    check: 'Number'
                },
                {
                    type: 'input_value',
                    name: 'pass2',
                    check: 'Number'
                },
                {
                    type: 'input_value',
                    name: 'pass3',
                    check: 'Number'
                },
                {
                    type: 'input_value',
                    name: 'pass4',
                    check: 'Number'
                },
                {
                    type: 'field_dropdown',
                    name: 'pin',
                    options: [
                        ['B0', '11'],
                        ['B1', '10']
                    ]
                }
            ],
            colour: '#05a2b0ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Mật khẩu',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // progress_password block
    ScratchBlocksInstance.Blocks.progress_password = {
        init: function() {
            this.jsonInit({
            message0: '%1 Kiểm tra mật khẩu Đúng hay Sai',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/password_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#05a2b0ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Mật khẩu',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // password_wrong block
    ScratchBlocksInstance.Blocks.password_wrong = {
        init: function() {
            this.jsonInit({
            message0: '%1 Mật khẩu Sai',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/password_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#05a2b0ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Mật khẩu',
            extensions: ["output_boolean"],
            });
        }
    };

    // password_true block
    ScratchBlocksInstance.Blocks.password_true = {
        init: function() {
            this.jsonInit({
            message0: '%1 Mật khẩu Đúng',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/password_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#05a2b0ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Mật khẩu',
            extensions: ["output_boolean"],
            });
        }
    };


    // password_done block
    ScratchBlocksInstance.Blocks.password_done = {
        init: function() {
            this.jsonInit({
            message0: '%1 Kiểm tra hoàn tất',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/password_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#05a2b0ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'Mật khẩu',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_test_scan block 
    ScratchBlocksInstance.Blocks.esp32_test_blocks = {
        init: function() {
            // Store reference to block for dynamic dropdown
            const block = this;
            
            this.jsonInit({
            message0: '%1 Khởi động cảm biến tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/circuit_board.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options: function() {
                        return getScannedDevicesAsOptions([['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'], ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'], ['16', '16'], ['17', '17'], ['18', '18'], ['19', '19'], ['20', '20'], ['21', '21'], ['22', '22'], ['23', '23'], ['24', '24'], ['25', '25'], ['26', '26'], ['27', '27'], ['28', '28'], ['29', '29'], ['30', '30'], ['31', '31']]);
                    }
                }
            ],
            colour: '#118b11ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_test_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_test_adc block 
    ScratchBlocksInstance.Blocks.esp32_test_adc = {
        init: function() {
            // Store reference to block for dynamic dropdown
            const block = this;
            
            this.jsonInit({
            message0: '%1 Khởi động cảm biến ADC tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/circuit_board.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options: function() {
                        return getScannedDevices_adc([['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'], ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'], ['16', '16'], ['17', '17'], ['18', '18'], ['19', '19'], ['20', '20'], ['21', '21'], ['22', '22'], ['23', '23'], ['24', '24'], ['25', '25'], ['26', '26'], ['27', '27'], ['28', '28'], ['29', '29'], ['30', '30'], ['31', '31']]);
                    }
                }
            ],
            colour: '#118b11ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_test_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_test_i2c block 
    ScratchBlocksInstance.Blocks.esp32_test_i2c = {
        init: function() {
            // Store reference to block for dynamic dropdown
            const block = this;
            
            this.jsonInit({
            message0: '%1 Khởi động cảm biến I2C tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/circuit_board.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options: function() {
                        return getScannedDevices_i2c([['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'], ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'], ['16', '16'], ['17', '17'], ['18', '18'], ['19', '19'], ['20', '20'], ['21', '21'], ['22', '22'], ['23', '23'], ['24', '24'], ['25', '25'], ['26', '26'], ['27', '27'], ['28', '28'], ['29', '29'], ['30', '30'], ['31', '31']]);
                    }
                }
            ],
            colour: '#118b11ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_test_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_rgb_sensor_start block 
    ScratchBlocksInstance.Blocks.esp32_rgb_sensor_start = {
        init: function() {
            // Store reference to block for dynamic dropdown
            const block = this;
            
            this.jsonInit({
            message0: '%1 Khởi động cảm biến màu sắc tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambienmausac.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options: function() {
                        return getScannedDevices_TCS3472([['0', '#define TCA_CHANNEL_TCS3472 1\n#define TCA_BUS_TCS3472 1'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'], ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'], ['16', '16'], ['17', '17'], ['18', '18'], ['19', '19'], ['20', '20'], ['21', '21'], ['22', '22'], ['23', '23'], ['24', '24'], ['25', '25'], ['26', '26'], ['27', '27'], ['28', '28'], ['29', '29'], ['30', '30'], ['31', '31']]);
                    }
                }
            ],
            colour: '#05a2b0ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_rgb_sensor_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_color_check block
    ScratchBlocksInstance.Blocks.esp32_color_check = {
        init: function() {
            this.jsonInit({
            message0: '%1 Màu sắc đọc được là %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambienmausac.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'color_value',
                    options: [
                        ['Đỏ', '1'],
                        ['Xanh lá', '2'],
                        ['Xanh dương', '3'],
                        ['Màu không xác định','0']
                    ]
                }
            ],
            colour: '#05a2b0ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_rgb_sensor_blocks',
            extensions: ["output_boolean"],
            });
        }
    };

    // esp32_rgb_color_value block
    ScratchBlocksInstance.Blocks.esp32_rgb_color_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Giá trị màu %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambienmausac.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'color_value',
                    options: [
                        ['Đỏ', '1'],
                        ['Xanh lá', '2'],
                        ['Xanh dương', '3']
                    ]
                }
            ],
            colour: '#05a2b0ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_rgb_sensor_blocks',
            extensions: ["output_number"],
            });
        }
    };

    // esp32_rgb_read_color_value block
    ScratchBlocksInstance.Blocks.esp32_rgb_read_color_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Hiển thị giá trị %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambienmausac.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type : 'input_value',
                    name : 'value',
                    check : 'Number'
                }
            ],
            colour: '#05a2b0ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_rgb_sensor_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_rgb_value block
    ScratchBlocksInstance.Blocks.esp32_rgb_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Đọc cảm biến màu sắc',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambienmausac.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#05a2b0ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_rgb_sensor_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_SR602_start block 
    ScratchBlocksInstance.Blocks.esp32_SR602_start = {
        init: function() {
            // Store reference to block for dynamic dropdown
            const block = this;
            
            this.jsonInit({
            message0: '%1 Khởi động cảm biến chuyển động tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/person_motion.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options: [
                        ['3', '3'],
                        ['4', '4'],
                        ['5', '5'],
                        ['6', '6'],
                        ['7', '7'],
                        ['9', '9'],
                        ['10', '10'],
                        ['13', '13'],
                        ['14', '14'],
                        ['15', '15'],
                        ['16', '16'],
                        ['17', '17'],
                        ['18', '18'],
                        ['21', '21'],
                        ['35', '35'],
                        ['36', '36'],
                        ['37', '37'],
                        ['38', '38'],
                        ['39', '39'],
                        ['40', '40'],
                        ['45', '45'],
                        ['46', '46'],
                        ['47', '47'],
                        ['48', '48']
                    ]
                }
            ],
            colour: '#f60e4cff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_SR602_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_SR602_check block
    ScratchBlocksInstance.Blocks.esp32_SR602_check = {
        init: function() {
            this.jsonInit({
            message0: '%1 Bắt được chuyển động',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/person_motion.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#f60e4cff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_SR602_blocks',
            extensions: ["output_boolean"],
            });
        }
    };

    // esp32_TCRT5000_start block 
    ScratchBlocksInstance.Blocks.esp32_TCRT5000_start = {
        init: function() {
            // Store reference to block for dynamic dropdown
            const block = this;
            
            this.jsonInit({
            message0: '%1 Khởi động cảm biến dò line %2 tại cổng %3 với ngưỡng %4',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambiendolineicon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'POSITION',
                    options:[['0', '0'], ['1', '1'], ['2', '2']]  
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options:[
                        ['3', '3'],
                        ['4', '4'],
                        ['5', '5'],
                        ['6', '6'],
                        ['7', '7'],
                        ['9', '9'],
                        ['10', '10'],
                        ['13', '13'],
                        ['14', '14'],
                        ['15', '15'],
                        ['16', '16'],
                        ['17', '17'],
                        ['18', '18'],
                        ['21', '21'],
                        ['35', '35'],
                        ['36', '36'],
                        ['37', '37'],
                        ['38', '38'],
                        ['39', '39'],
                        ['40', '40'],
                        ['45', '45'],
                        ['46', '46'],
                        ['47', '47'],
                        ['48', '48']
                    ]
                },
                {
                    type : 'input_value',
                    name : 'value',
                    check : 'Number'
                }
            ],
            colour: '#d69429ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_TCRT5000_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_TCRT5000_check block
    ScratchBlocksInstance.Blocks.esp32_TCRT5000_check = {
        init: function() {
            this.jsonInit({
            message0: '%1 Phát hiện đường đi tại cảm biến %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambiendolineicon.svg',     // Cambienvatcanicon.svg
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'POSITION',
                    options:[['0', '0'], ['1', '1'], ['2', '2']]  
                }
            ],
            colour: '#d69429ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_TCRT5000_blocks',
            extensions: ["output_boolean"],
            });
        }
    };

    // esp32_VL6180X_start block 
    ScratchBlocksInstance.Blocks.esp32_VL6180X_start = {
        init: function() {
            // Store reference to block for dynamic dropdown
            const block = this;
            
            this.jsonInit({
            message0: '%1 Khởi động cảm biến lazer khoảng cách tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/cambienkhoangcachicon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options: function() {
                        return getScannedDevices_VL6180X([['0', '#define VL6180_SENSOR0_CHANNEL 1\n#define VL6180_SENSOR0_BUS 1\nVL6180X sensor0;\n'], ['1', '#define VL6180_SENSOR1_CHANNEL 1\n#define VL6180_SENSOR1_BUS 1\nVL6180X sensor1;\n']]);
                    }
                }
            ],
            colour: '#118b11ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_VL6180X_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_VL6180X_value block
    ScratchBlocksInstance.Blocks.esp32_VL6180X_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Giá trị khoảng cách %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/cambienkhoangcachicon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options: function() {
                        return getScannedDevices_VL6180X([['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'], ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'], ['16', '16'], ['17', '17'], ['18', '18'], ['19', '19'], ['20', '20'], ['21', '21'], ['22', '22'], ['23', '23'], ['24', '24'], ['25', '25'], ['26', '26'], ['27', '27'], ['28', '28'], ['29', '29'], ['30', '30'], ['31', '31']]);
                    }
                }
            ],
            colour: '#118b11ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_VL6180X_blocks',
            extensions: ["output_number"],
            });
        }
    };

    // esp32_VL6180X_read_distance_value block
    ScratchBlocksInstance.Blocks.esp32_VL6180X_read_distance_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Hiển thị giá trị khoảng cách %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/cambienkhoangcachicon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type : 'input_value',
                    name : 'value',
                    check : 'Number'
                }
            ],
            colour: '#118b11ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_VL6180X_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_HW484_start block 
    ScratchBlocksInstance.Blocks.esp32_HW484_start = {
        init: function() {
            // Store reference to block for dynamic dropdown
            const block = this;
            
            this.jsonInit({
            message0: '%1 Khởi động cảm biến phát hiện lửa tại cổng %2 với ngưỡng %3',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/cambienlua.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options: function() {
                        return getScannedDevices_HW484([ ['0', '#define FLAME_HW484_A0 0\n'], ['1', '#define FLAME_HW484_A0 1\n'] ]);
                    }
                },
                {
                    type : 'input_value',
                    name : 'value',
                    check : 'Number'
                }
            ],
            colour: '#ff22fbff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_HW484_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_HW484_check block
    ScratchBlocksInstance.Blocks.esp32_HW484_check = {
        init: function() {
            this.jsonInit({
            message0: '%1 Phát hiện lửa',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/cambienlua.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#ff22fbff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_HW484_blocks',
            extensions: ["output_boolean"],
            });
        }
    };

    // esp32_MQ2_Smoke_start block
    ScratchBlocksInstance.Blocks.esp32_MQ2_Smoke_start = {
        init: function() {
            // Store reference to block for dynamic dropdown
            const block = this;
            
            this.jsonInit({
            message0: '%1 Khởi động cảm biến phát hiện Khói tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/cambienkhoi.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options:[['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'], ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'], ['16', '16'], ['17', '17'], ['18', '18'], ['19', '19'], ['20', '20'], ['21', '21'], ['22', '22'], ['23', '23'], ['24', '24'], ['25', '25'], ['26', '26'], ['27', '27'], ['28', '28'], ['29', '29'], ['30', '30'], ['31', '31']]  
                }
            ],
            colour: '#D32F2F',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_MQ2_Smoke_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_MQ2_Smoke_check block
    ScratchBlocksInstance.Blocks.esp32_MQ2_Smoke_check = {
        init: function() {
            this.jsonInit({
            message0: '%1 Mức độ %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/cambienkhoi.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'value',
                    options: [
                        ['Bình thường', 'TRONG LANH (SAFE)'],
                        ['Cảnh báo', 'CANH BAO (WARNING)'],
                        ['Nguy hiểm', 'NGUY HIEM (ALARM)']
                    ]
                }
            ],
            colour: '#D32F2F',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_MQ2_Smoke_blocks',
            extensions: ["output_boolean"],
            });
        }
    };

    // esp32_BME680_start block
    ScratchBlocksInstance.Blocks.esp32_BME680_start = {
        init: function() {
            const block = this;
            this.jsonInit({
            message0: '%1 Khởi động cảm biến nhiệt độ và độ ẩm tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambiennhietdodoamicon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options: function() {
                        return getScannedDevices_BME680([['0', '#define BME680_BUS 0\n#define BME680_CHANNEL 3\n'], ['1', '#define BME680_CHANNEL 3\n#define BME680_BUS 0\n']]);
                    }
                }
            ],
            colour: '#F9A825',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_BME680_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_BME680_temperature_value block
    ScratchBlocksInstance.Blocks.esp32_BME680_temperature_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Giá trị nhiệt độ',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambiennhietdodoamicon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#F9A825',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_BME680_blocks',
            extensions: ["output_number"],
            });
        }
    };

    // esp32_BME680_humidity_value block
    ScratchBlocksInstance.Blocks.esp32_BME680_humidity_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Giá trị độ ẩm',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambiennhietdodoamicon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#F9A825',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_BME680_blocks',
            extensions: ["output_number"],
            });
        }
    };

    // esp32_BME680_pressure_value block
    ScratchBlocksInstance.Blocks.esp32_BME680_pressure_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Giá trị áp suất',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambiennhietdodoamicon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#F9A825',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_BME680_blocks',
            extensions: ["output_number"],
            });
        }
    };

    // esp32_BME680_air_value block
    ScratchBlocksInstance.Blocks.esp32_BME680_air_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Giá trị chất lượng không khí',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambiennhietdodoamicon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#F9A825',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_BME680_blocks',
            extensions: ["output_number"],
            });
        }
    };

    // esp32_BME680_read_value block
    ScratchBlocksInstance.Blocks.esp32_BME680_read_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Hiển thị giá trị %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/Cambiennhietdodoamicon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'value',
                    options: [
                        ['Nhiệt độ', `Serial.print("Nhiệt độ: ");\nSerial.print(readBME680(1));\nSerial.println(" °C");`],
                        ['Độ ẩm', `Serial.print("Độ ẩm: ");\nSerial.print(readBME680(2));\nSerial.println(" %");`],
                        ['Áp suất', `Serial.print("Áp suất: ");\nSerial.print(readBME680(3));\nSerial.println(" hPa");`],
                        ['Chất lượng không khí', `Serial.print("Chất lượng không khí: ");\nSerial.print(readBME680(4)/1000.0);\nSerial.println(" KOhms");`]
                    ]
                }
            ],
            colour: '#F9A825',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_BME680_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_WB2812_Led_start block
    ScratchBlocksInstance.Blocks.esp32_WB2812_Led_start = {
        init: function() {
            // Store reference to block for dynamic dropdown
            const block = this;
            
            this.jsonInit({
            message0: '%1 Khởi tạo đèn LED WS2812 tại cổng %2 với số lượng %3',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/EspLedIcon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options:[['35', '35'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'], ['12', '12'], ['13 ', '13'], ['14', '14'], ['15', '15'], ['16', '16'], ['17', '17'], ['18', '18'], ['19', '19'], ['20', '20'], ['21', '21'], ['22', '22'], ['23', '23'], ['24', '24'], ['25', '25'], ['26', '26'], ['27', '27'], ['28', '28'], ['29', '29'], ['30', '30'], ['31', '31']]  
                },
                {
                    type : 'input_value',
                    name : 'value',
                    check : 'Number'
                }
            ],
            colour: '#ff8800ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_WB2812_Led_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_WB2812_set_color block
    ScratchBlocksInstance.Blocks.esp32_WB2812_set_color = {
        init: function() {
            this.jsonInit({
            message0: '%1 Đặt màu đèn LED tại vị trí %2 với màu đỏ %3 màu xanh lá %4 màu xanh dương %5',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/EspLedIcon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type : 'input_value',
                    name : 'position',
                    check : 'Number'
                },
                {
                    type : 'input_value',
                    name : 'red',
                    check : 'Number'
                },
                {
                    type : 'input_value',
                    name : 'green',
                    check : 'Number'
                },
                {
                    type : 'input_value',
                    name : 'blue',
                    check : 'Number'
                }
            ],
            colour: '#ff8800ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_WB2812_Led_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_WB2812_effect block
    ScratchBlocksInstance.Blocks.esp32_WB2812_effect = {
        init: function() {
            this.jsonInit({
            message0: '%1 Hiệu ứng đèn LED %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/EspLedIcon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'EFFECT',
                    options: [
                        ['Chạy sáng', 'runningLight()'],
                        ['Chớp tắt', 'flashCurrentHue(1, 40);'],
                        ['Tua sáng', 'theaterChase()'],
                        ['Cầu vồng', 'rainbow();']
                    ]
                }
            ],
            colour: '#ff8800ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_WB2812_Led_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_Oled_start block
    ScratchBlocksInstance.Blocks.esp32_Oled_start = {
        init: function() {
            // Store reference to block for dynamic dropdown
            const block = this;
            
            this.jsonInit({
            message0: '%1 Khởi động màn hình OLED tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/screen_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options: function() {
                        return getScannedDevices_OLED([['0', '#define OLED_BUS 1\n#define OLED_CHANNEL 3\n']]);
                    }
                }
            ],
            colour: '#008080ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_Oled_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_Oled_display block
    ScratchBlocksInstance.Blocks.esp32_Oled_display = {
        init: function() {
            this.jsonInit({
            message0: '%1 Hiển thị trên màn hình OLED: %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/screen_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type : 'field_dropdown',
                    name : 'value',
                    options: [
                        ['Con mèo', '0'],
                        ['Con chuột', '1'],
                        ['Con trâu', '3'],
                        ['Con chó', '2'],
                        ['Con hổ', '4'],
                        ['Con rồng', '5'],
                        ['Con rắn', '6'],
                        ['Con lợn', '7'],
                        ['Con ngựa', '8'],
                        ['Con dê', '9'],
                        ['Con khỉ', '10'],
                        ['Con gà', '11']
                    ]
                }
            ],
            colour: '#008080ff',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_Oled_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_Servo_start block
    ScratchBlocksInstance.Blocks.esp32_Servo_start = {
        init: function() {
            this.jsonInit({
            message0: '%1 Khởi động servo tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/servo_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type : 'field_dropdown',
                    name : 'PORT',
                    options: [
                        ['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'], ['12', '12'], ['13 ', '13'], ['14', '14'], ['15', '15'], ['16', '16'], ['17', '17'], ['18', '18'], ['19', '19'], ['20', '20'], ['21', '21'], ['22', '22'], ['23', '23'], ['24', '24'], ['25', '25'], ['26', '26'], ['27', '27'], ['28', '28'], ['29', '29'], ['30', '30'], ['31', '31']
                    ]
                }
            ],
            colour: '#9B59B6',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_Servo_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_Servo_set_angle block
    ScratchBlocksInstance.Blocks.esp32_Servo_set_angle = {
        init: function() {
            this.jsonInit({
            message0: '%1 Đặt góc servo tại cổng %2 góc %3 độ',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/servo_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type : 'field_dropdown',
                    name : 'PORT',
                    options: [
                        ['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'], ['12', '12'], ['13 ', '13'], ['14', '14'], ['15', '15'], ['16', '16'], ['17', '17'], ['18', '18'], ['19', '19'], ['20', '20'], ['21', '21'], ['22', '22'], ['23', '23'], ['24', '24'], ['25', '25'], ['26', '26'], ['27', '27'], ['28', '28'], ['29', '29'], ['30', '30'], ['31', '31']
                    ]
                },
                {
                    type : 'input_value',
                    name : 'angle',
                    check : 'Number'
                }
            ],
            colour: '#9B59B6',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_Servo_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_Motor_Start Block
    ScratchBlocksInstance.Blocks.esp32_Motor_Start = {
        init: function() {
            this.jsonInit({
                message0: '%1 Khởi động động cơ',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    }
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'esp32_Motor_blocks'
            });
        }
    };

    // esp32_motor_custom block
    ScratchBlocksInstance.Blocks.esp32_motor_custom = {
        init: function() {
            this.jsonInit({
            message0: '%1 Động cơ tại cổng %2  %3 với tốc độ %4',
            args0: [
                {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'motor',
                    options: [
                        ['A', 'A'],
                        ['B', 'B']     
                    ]
                },
                {
                    type: 'field_dropdown',
                    name: 'mode',
                    options: [
                        ['Tien', 'forward'],
                        ['Lui', 'backward'],
                        ['Dung', 'stop']
                    ]
                },
                {
                    type : 'input_value',
                    name : 'speed',
                    check : 'Number'
                }
            ],
            colour: '#D32F2F',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            previousStatement: null,
            nextStatement: null,
            category: 'esp32_Motor_blocks'
            });
        }
    };


    // esp32_motor_back motor Backward Block
    ScratchBlocksInstance.Blocks.esp32_motor_back = {
        init: function() {
            this.jsonInit({
                message0: '%1 Robot lùi lại với tốc độ %2',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                    {
                        type : 'input_value',
                        name : 'speed',
                        check : 'Number'
                    }
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'esp32_Motor_blocks'
            });
        }
    };

    // esp32_motor_turn_right Block
    ScratchBlocksInstance.Blocks.esp32_motor_turn_right = {
        init: function() {
            this.jsonInit({
                message0: '%1 Robot rẽ phải với tốc độ %2',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                    {
                        type : 'input_value',
                        name : 'speed',
                        check : 'Number'
                    }
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'esp32_Motor_blocks'
            });
        }
    };

    // esp32_motor_turn_left Block
    ScratchBlocksInstance.Blocks.esp32_motor_turn_left = {
        init: function() {
            this.jsonInit({
                message0: '%1 Robot rẽ trái với tốc độ %2',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                    {
                        type : 'input_value',
                        name : 'speed',
                        check : 'Number'
                    }
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'esp32_Motor_blocks'
            });
        }
    };

    // esp32_motor_turn_left Block
    ScratchBlocksInstance.Blocks.esp32_motor_forward = {
        init: function() {
            this.jsonInit({
                message0: '%1 Robot tiến lên với tốc độ %2',
                args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                    {
                        type : 'input_value',
                        name : 'speed',
                        check : 'Number'
                    }
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'esp32_Motor_blocks'
            });
        }
    };

    // esp32_motor_stop Block
    ScratchBlocksInstance.Blocks.esp32_motor_stop = {
        init: function() {
            this.jsonInit({
                message0: '%1 Robot dừng lại',
                args0: [
                    {   
                        type: 'field_image',
                        src: 'static/assets/motor_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    },
                ],
                colour: '#D32F2F',
                colourSecondary: '#ffffff',
                colourTertiary: '#d4cbcbff',
                previousStatement: null,
                nextStatement: null,
                category: 'esp32_Motor_blocks'
            });
        }
    };

    // esp32_button_start block
    ScratchBlocksInstance.Blocks.esp32_button_start = {
        init: function() {
            this.jsonInit({
            message0: '%1 Khởi động nút nhấn',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/button_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#9966FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_button_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_left_button_value block
    ScratchBlocksInstance.Blocks.esp32_left_button_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Nút nhấn bên trái bằng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/button_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'button_value',
                    check: 'Number'
                }
            ],
            colour: '#9966FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_button_blocks',
            extensions: ["output_boolean"],
            });
        }
    };

    // esp32_right_button_value block
    ScratchBlocksInstance.Blocks.esp32_right_button_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Nút nhấn bên phải bằng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/button_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'button_value',
                    check: 'Number'
                }
            ],
            colour: '#9966FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_button_blocks',
            extensions: ["output_boolean"],
            });
        }
    };

    // esp32_setting_toggle_button block
    ScratchBlocksInstance.Blocks.esp32_setting_toggle_button = {
        init: function() {
            this.jsonInit({
            message0: '%1 Cài đặt số lần nhấn nút bên phải bằng %2 , số lần nhấn nút bên trái bằng %3',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/button_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'right_button_value',
                    check: 'Number'
                },
                {
                    type: 'input_value',
                    name: 'left_button_value',
                    check: 'Number'
                }
            ],
            colour: '#9966FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_button_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_led_start block
    ScratchBlocksInstance.Blocks.esp32_led_start = {
        init: function() {
            const block = this;      
            this.jsonInit({
            message0: '%1 Khởi động đèn LED tích hợp tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/led_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options:[['2', '2'], ['4', '4'], ['11', '11'], ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'], ['25', '25'], ['26', '26'], ['27', '27'], ['32', '32'], ['33', '33']]  
                }
            ],
            colour: '#3300FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_led_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_led_mode_on_pin block
    ScratchBlocksInstance.Blocks.esp32_led_mode_on_pin = {
        init: function() {
            this.jsonInit({
            message0: '%1 %2 đèn led',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/led_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'mode',
                    options: [
                        ['Bật', '100'],
                        ['Tắt', '0']     
                    ]
                },
                // {
                //     type: 'field_dropdown',
                //     name: 'pin',
                //     options: [
                //         ['1', '11'],
                //         ['2', '12']     
                //     ]
                // }
            ],
            colour: '#3300FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_led_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_led_on_effect block
    ScratchBlocksInstance.Blocks.esp32_led_on_effect = {
        init: function() {
            this.jsonInit({
            message0: '%1 Đèn sáng dần trong %2 giây',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/led_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'time',
                    check: 'Number'
                },
                // {
                //     type: 'field_dropdown',
                //     name: 'pin',
                //     options: [
                //         ['1', '11'],
                //         ['2', '12']     
                //     ]
                // }
            ],
            colour: '#3300FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_led_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };    

    // esp32_led_off_effect block
    ScratchBlocksInstance.Blocks.esp32_led_off_effect = {
        init: function() {
            this.jsonInit({
            message0: '%1 Đèn tối dần trong %2 giây',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/led_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'time',
                    check: 'Number'
                },
                // {
                //     type: 'field_dropdown',
                //     name: 'pin',
                //     options: [
                //         ['1', '11'],
                //         ['2', '12']     
                //     ]
                // }
            ],
            colour: '#3300FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_led_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    }; 

    // esp32_led_on_intensity block
    ScratchBlocksInstance.Blocks.esp32_led_on_intensity = {
        init: function() {
            this.jsonInit({
            message0: '%1 Bật đèn với mức sáng %2 (0-100%)',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/led_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                // {
                //     type: 'field_dropdown',
                //     name: 'pin',
                //     options: [
                //         ['1', '11'],
                //         ['2', '12']     
                //     ]
                // },
                {
                    type: 'input_value',
                    name: 'intensity',
                    check: 'Number'
                } 
            ],
            colour: '#3300FF',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_led_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_wifi block
    ScratchBlocksInstance.Blocks.esp32_wifi = {
        init: function() {
            this.jsonInit({
            message0: '%1 Phát wifi  với SSID: %2 Mật khẩu: %3',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/wifi_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'ssid',
                    check: 'String'
                },
                {
                    type: 'input_value',
                    name: 'password',
                    check: 'String'
                }
            ],
            colour: '#00CC66',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_wifi_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_button_clicked block
    ScratchBlocksInstance.Blocks.esp32_button_clicked = {
        init: function() {
            this.jsonInit({
            message0: '%1 Nút %2 được nhấn',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/button_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'button_side',
                    options: [
                        ['tiến lên', 'up_start'],
                        ['lùi lại', 'down_start'],
                        ['rẽ trái', 'left_start'],
                        ['rẽ phải', 'right_start'],
                        ['OK', 'ok']   
                    ]
                }
            ],
            colour: '#00CC66',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_wifi_blocks',
            extensions: ["output_boolean"],
            });
        }
    };

    // esp32_wifi_input block
    ScratchBlocksInstance.Blocks.esp32_wifi_input = {
        init: function() {
            this.jsonInit({
            message0: '%1 Dữ liệu nhập vào',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/wifi_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#00CC66',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_wifi_blocks',
            extensions: ["output_string"],
            });
        }
    };

    // esp32_bluetooth_start block
    ScratchBlocksInstance.Blocks.esp32_bluetooth_start = {
        init: function() {
            this.jsonInit({
            message0: '%1 Phát bluetooth với tên hiển thị %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/bluetooth_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'input_value',
                    name: 'display_name',
                    check: 'String'
                }
            ],
            colour: '#333333',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_bluetooth_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_soil_moisture_start block
    ScratchBlocksInstance.Blocks.esp32_soil_moisture_start = {
        init: function() {
            const block = this;      
            this.jsonInit({
            message0: '%1 Khởi động cảm biến độ ẩm đất tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/ground_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options:[['4', '4'], ['11', '11'], ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'], ['25', '25'], ['26', '26'], ['27', '27'], ['32', '32'], ['33', '33']]  
                }
            ],
            colour: '#660066',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_soil_moisture_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_soil_moisture_value block
    ScratchBlocksInstance.Blocks.esp32_soil_moisture_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Độ ẩm đất (%)',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/ground_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#660066',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_soil_moisture_blocks',
            extensions: ["output_number"],
            });
        }
    };

    // esp32_temperature_artical_start block
    ScratchBlocksInstance.Blocks.esp32_temperature_artical_start = {
        init: function() {
            const block = this;      
            this.jsonInit({
            message0: '%1 Khởi động cảm biến nhiệt độ tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/temperature_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options:[['4', '4'], ['11', '11'], ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'], ['25', '25'], ['26', '26'], ['27', '27'], ['32', '32'], ['33', '33']]  
                }
            ],
            colour: '#FF3366',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_temperature_artical_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_temperature_artical_value block
    ScratchBlocksInstance.Blocks.esp32_temperature_artical_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Nhiệt độ (°C)',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/temperature_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                }
            ],
            colour: '#FF3366',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_temperature_artical_blocks',
            extensions: ["output_number"],
            });
        }
    };

    // esp32_light_sensor block
    ScratchBlocksInstance.Blocks.esp32_light_sensor = {
        init: function() {
            const block = this;      
            this.jsonInit({
            message0: '%1 Cảm biến ánh sáng tại cổng %2',
            args0: [
                {
                    type: 'field_image',
                    src: 'static/assets/sun_icon.svg',
                    width: 24,
                    height: 24,
                    alt: '*'
                },
                {
                    type: 'field_dropdown',
                    name: 'PORT',
                    options: [
                    ['3', '3'],
                    ['4', '4'],
                    ['5', '5'],
                    ['6', '6'],
                    ['7', '7'],
                    ['9', '9'],
                    ['10', '10'],
                    ['13', '13'],
                    ['14', '14'],
                    ['15', '15'],
                    ['16', '16'],
                    ['17', '17'],
                    ['18', '18'],
                    ['21', '21'],
                    ['35', '35'],
                    ['36', '36'],
                    ['37', '37'],
                    ['38', '38'],
                    ['39', '39'],
                    ['40', '40'],
                    ['45', '45'],
                    ['46', '46'],
                    ['47', '47'],
                    ['48', '48']
                    ] 
                }
            ],
            colour: '#0B3D20',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_light_sensor_blocks',
            previousStatement: null,
            nextStatement: null,
            });
        }
    };

    // esp32_light_sensor_value block
    ScratchBlocksInstance.Blocks.esp32_light_sensor_value = {
        init: function() {
            this.jsonInit({
            message0: '%1 Đo độ sáng (0-100%)',
            args0: [
                    {
                        type: 'field_image',
                        src: 'static/assets/sun_icon.svg',
                        width: 24,
                        height: 24,
                        alt: '*'
                    }
                ],
            colour: '#0B3D20',
            colourSecondary: '#ffffff',
            colourTertiary: '#d4cbcbff',
            category: 'esp32_light_sensor_blocks',
            extensions: ["output_number"],
            });
        }
    };
}

export default defineDemoBlocks;
